import { clearAiCache } from "../ai/services/aiCacheService";
import { clearSchemaCache } from "../ai/services/aiSchemaService";
import { clearMemoryForConnection } from "../ai/services/conversationMemoryService";
import { clearAllLocalSessions } from "../ai/services/aiSessionService";
import { clearQueryHistory } from "../../firestoreAdmin/services/queryHistoryService";
import { clearAllExplorerPrefs } from "../../firestoreAdmin/explorer/explorerPrefsService";
import { clearAllSavedViews } from "../../firestoreAdmin/services/savedViewsService";
import { FA_FAVORITES_KEY, FA_RECENT_KEY } from "../../firestoreAdmin/constants";

const AGENT_MEMORY_KEY = "firestoreStudio.agents.memory";
const AGENT_SETTINGS_KEY = "firestoreStudio.agents.settings";
const AGENT_NOTIFICATIONS_KEY = "firestoreStudio.agents.notifications";
const AGENT_HEALTH_KEY = "firestoreStudio.agents.health";
const AGENT_LEARNING_KEY = "firestoreStudio.agents.learning";
const AGENT_RULES_KEY = "firestoreStudio.agents.autonomous.rules";
const AGENT_NOTIFICATION_QUEUE_KEY = "firestoreStudio.agents.notificationQueue";

function removeLocalStorageKey(key) {
  try {
    localStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}

function clearAgentLocalCaches() {
  removeLocalStorageKey(AGENT_MEMORY_KEY);
  removeLocalStorageKey(AGENT_SETTINGS_KEY);
  removeLocalStorageKey(AGENT_NOTIFICATIONS_KEY);
  removeLocalStorageKey(AGENT_HEALTH_KEY);
  removeLocalStorageKey(AGENT_LEARNING_KEY);
  removeLocalStorageKey(AGENT_RULES_KEY);
  removeLocalStorageKey(AGENT_NOTIFICATION_QUEUE_KEY);
}

function clearExplorerSidebarPrefs() {
  removeLocalStorageKey(FA_FAVORITES_KEY);
  removeLocalStorageKey(FA_RECENT_KEY);
}

/**
 * Remove Studio-local caches tied to a connection. Never touches customer Firebase data.
 */
export function clearConnectionLocalCaches(connectionId, { wasWorkspaceConnection = false } = {}) {
  clearMemoryForConnection(connectionId);
  clearAiCache();
  clearSchemaCache();

  if (wasWorkspaceConnection) {
    clearAllLocalSessions();
    clearQueryHistory();
    clearAllExplorerPrefs();
    clearAllSavedViews();
    clearExplorerSidebarPrefs();
    clearAgentLocalCaches();
  }
}
